/**
 * 补充英文文案（与 partial-zh 键一一对应，供 LanguageContext 合并）
 */
export const partialEn: Record<string, string> = {
  "common.langShortEn": "EN",
  "common.langShortZh": "中文",

  "whitepaper.banner": "🎉 OranAI Whitepaper is now live!",
  "whitepaper.details": "Details",
  "whitepaper.closeAria": "Close",

  "home.hero.subtitle":
    "One-stop Solution to Marketing Challenges, All-round Support for Brand Growth",
  "home.hero.s1": "Integrate cutting-edge ",
  "home.hero.em1": "Models",
  "home.hero.s2": ", ",
  "home.hero.em2": "Product Matrices",
  "home.hero.s3": ", and ",
  "home.hero.em3": "Creative Asset Libraries",
  "home.hero.s4": " to build a ",
  "home.hero.em4": "One-stop Marketing Solution",
  "home.hero.s5": ", empowering the growth of ",
  "home.hero.em5": "Global Brands",
  "home.hero.s6": ".",

  "auth.error.loginFailed": "Login failed. Please try again.",
  "auth.error.registerFailed": "Registration failed. Please try again.",
  "auth.error.passwordMismatch": "Passwords do not match",
  "auth.error.verificationRequired": "Please enter verification code",
  "auth.error.emailRequired": "Please enter your email address",
  "auth.error.emailInvalid": "Please enter a valid email address",
  "auth.error.sendCodeFailed": "Failed to send verification code. Please try again.",
  "auth.error.googleUrlFailed": "Failed to get Google login link.",
  "auth.error.googleLoginFailed": "Google login failed. Please try again.",
  "auth.error.resetFailed": "Reset password failed. Please try again.",
  "auth.error.codeRequiredForgot": "Please enter the verification code",
  "auth.error.newPasswordRequired": "Please enter your new password",
  "auth.error.passwordMin": "Password must be at least 6 characters",
  "auth.error.passwordMismatchForgot": "Passwords do not match",
  "auth.toast.passwordResetOk": "Password reset successfully",

  "header.signOutAria": "Sign Out",
  "header.signOut": "Sign Out",
  "header.signIn": "Sign In",
  "header.accountMenuAria": "Account menu",

  "auth.forgot.title": "Forget password",
  "auth.label.email": "Email Address",
  "auth.placeholder.email": "Email",
  "auth.label.code": "Verification Code",
  "auth.placeholder.code": "Verification Code",
  "auth.sendCode.sending": "Sending...",
  "auth.sendCode.seconds": "s",
  "auth.sendCode": "Send Code",
  "auth.label.newPassword": "New Password",
  "auth.placeholder.password": "Password",
  "auth.label.confirmPassword": "Confirm Password",
  "auth.placeholder.confirm": "Confirm",
  "auth.placeholder.confirmSignup": "Confirm",
  "auth.login.loggingIn": "Logging in...",
  "common.or": "or",
  "auth.alreadyHaveAccount": "Already have an account?",
  "auth.loginCta": "Login",
  "auth.resetting": "Resetting...",
  "auth.resetPassword": "Reset Password",
  "auth.terms.prefix": "By continuing, you agree to our ",
  "auth.terms.service": "Terms of Service",
  "auth.terms.mid": " and acknowledge our ",
  "auth.terms.privacy": "Privacy Policy",

  "auth.signup.title": "Sign up for an account",
  "auth.signup.submitting": "Signing up...",
  "auth.signup.cta": "Sign Up",
  "auth.alreadyHaveAccountAlt": "Already have an account?",

  "auth.placeholder.inviteCode": "Invite code (optional)",

  "auth.login.title": "Create an account or Login",
  "auth.google.redirecting": "Redirecting...",
  "auth.google.continue": "Continue with Google",
  "auth.continueEmail": "Continue with email",
  "auth.login.submitting": "Signing in...",
  "auth.login.submit": "Sign In",
  "auth.signUpLink": "Sign Up",
  "auth.forgotLink": "Forgot Password",

  "header.mega.scenarioTitle": "Scenario Solutions",
  "header.mega.industryTitle": "Industry Solutions",
  "header.mega.platformTitle": "Platform Capabilities",
  "header.mega.productTitle": "Product Matrix",
  "header.mega.libraryTitle": "Inspiration Library",

  "menu.sol.geo": "GEO",
  "menu.sol.social": "Social Media Marketing",
  "menu.sol.email": "Email Marketing",
  "menu.sol.sales": "Sales Support",
  "menu.ind.beauty": "Beauty & FMCG",
  "menu.ind.electronics": "Consumer Electronics",
  "menu.ind.crossborder": "Cross-border Expansion",
  "menu.ind.data": "Data Infrastructure",
  "menu.plat.dataCenter": "Data Center",
  "menu.plat.modelLibrary": "Model Library",
  "menu.plat.skills": "Skills",
  "menu.prod.dataInfra": "Data Infrastructure",
  "menu.prod.insights": "Insights Hub",
  "menu.prod.strategy": "Strategy Engine",
  "menu.prod.contentFactory": "Content Factory",
  "menu.lib.video": "Video",
  "menu.lib.voice": "Voice",
  "menu.lib.model": "Model",

  "pricing.plan.free": "Free",
  "pricing.plan.starter": "Starter",
  "pricing.plan.basic": "Basic",
  "pricing.plan.pro": "Pro",
  "pricing.plan.enterprise": "Enterprise",

  "pricing.mailto.subject": "OranAI Enterprise Inquiry",
  "pricing.mailto.body":
    "Hi, I'd like to inquire about OranAI Enterprise.\nUse case: ________\nContact: ________",

  "pricing.hero.title": "Choose the plan that fits you",
  "pricing.hero.subtitle":
    "Use OranAI's insights and creative tools to grow faster.",

  "pricing.action.contactSales": "Contact Sales",
  "pricing.action.currentPlan": "Current Plan",
  "pricing.action.upgradeTo": "Upgrade to {{plan}}",
  "pricing.action.switchTo": "Switch to {{plan}}",

  "pricing.plans.free.name": "Free",
  "pricing.plans.free.desc": "Sign up and start exploring AI features",
  "pricing.plans.free.credits": "20 credits",
  "pricing.plans.free.creditsNote": "One-time",

  "pricing.plans.starter.name": "Starter",
  "pricing.plans.starter.desc": "For new creators - daily image gen & insight reports",
  "pricing.plans.starter.price": "$19.90",
  "pricing.plans.starter.priceSub": "/ month",
  "pricing.plans.starter.credits": "1353 credits",
  "pricing.plans.starter.creditsNote": "Recharge credits",

  "pricing.plans.basic.name": "Basic",
  "pricing.plans.basic.desc": "For growing creators - higher-frequency content & insights",
  "pricing.plans.basic.price": "$59.90",
  "pricing.plans.basic.priceSub": "/ month",
  "pricing.plans.basic.credits": "4073 credits",
  "pricing.plans.basic.creditsNote": "Recharge credits",

  "pricing.plans.pro.name": "Pro",
  "pricing.plans.pro.desc": "For power users - high-frequency reports & video rendering",
  "pricing.plans.pro.price": "$199.90",
  "pricing.plans.pro.priceSub": "/ month",
  "pricing.plans.pro.credits": "13593 credits",
  "pricing.plans.pro.creditsNote": "Recharge credits",

  "pricing.plans.enterprise.name": "Enterprise",
  "pricing.plans.enterprise.desc": "For large organizations - custom contracts",

  "pricing.badge.popular": "Most Popular",
  "pricing.enterprise.customPrice": "Custom",
  "pricing.enterprise.customCredits": "Custom Credits",

  "pricing.cta.needMore": "Need more credits?",
  "pricing.cta.buyTopUp": "Buy top-up packs",
  "pricing.section.comparison": "Plan Comparison",
  "pricing.section.faq": "Frequently Asked Questions",
  "pricing.comparison.featureCol": "Feature",
  "pricing.comparison.infinity": "∞",
  "pricing.quota.unlimited": "Unlimited",

  "pricing.faq.0.q": "Do Credits expire?",
  "pricing.faq.0.a":
    "Subscription credits reset monthly (use-it-or-lose-it), calculated to the minute from purchase time. Top-up credits expire one month after purchase.",
  "pricing.faq.1.q": "Can I cancel my subscription anytime?",
  "pricing.faq.1.a":
    "Yes. Cancel auto-renewal anytime. Benefits remain until the period ends, then downgrade.",
  "pricing.faq.2.q": "What are the upgrade rules?",
  "pricing.faq.2.a":
    "Plan switches immediately upon payment with full new Credits. Old plan time is not prorated or carried over.",
  "pricing.faq.3.q": "How do top-up packs work?",
  "pricing.faq.3.a":
    "One-off payment, no recurring billing. Credits expire one month after purchase.",
  "pricing.faq.4.q": "Do you support refunds?",
  "pricing.faq.4.a":
    "We do not support refunds, downgrades, or lateral plan changes. Contact sales for special requests.",

  "pricing.bottom.title": "Ready to start with OranAI?",
  "pricing.bottom.subscribe": "Subscribe",

  "pricing.checkout.noUrl": "No checkout URL returned. Please try again or contact support.",
  "pricing.checkout.failed": "Could not start checkout",
  "pricing.checkout.inProgress": "Redirecting to payment…",
  "pricing.checkout.sameOrHigherTier": "You are already on this plan or a higher tier.",

  "billing.checkout.success.title": "Payment status",
  "billing.checkout.success.loading": "Confirming your order…",
  "billing.checkout.success.awaitingGateway":
    "Checkout created; waiting for payment confirmation. If you have not finished paying, return to the payment page. If you have, wait a moment or tap refresh below.",
  "billing.checkout.success.awaitingAfterReturn":
    "You are back from the payment page; waiting for the order to update. Continue paying below if needed, or refresh status in a moment.",
  "billing.checkout.success.continuePay": "Open payment page",
  "billing.checkout.success.paidTitle": "Payment successful",
  "billing.checkout.success.paidDesc":
    "Your order is confirmed. Subscription benefits may take a moment to appear—refresh the pricing page if needed.",
  "billing.checkout.success.failedTitle": "Payment not completed",
  "billing.checkout.success.pendingTitle": "Still processing",
  "billing.checkout.success.pendingDesc":
    "The payment provider may need a little time. Refresh this page or check your plan on the pricing page.",
  "billing.checkout.success.missingOrderId":
    "Missing order id. Open the link from your payment confirmation or contact support.",
  "billing.checkout.success.needLogin": "Sign in to view your order status.",
  "billing.checkout.success.goPricing": "Go to pricing",
  "billing.checkout.success.goHome": "Back to home",
  "billing.checkout.success.refresh": "Refresh status",
  "billing.checkout.success.orderNo": "Order no.",
  "billing.checkout.success.orderId": "Order ID",

  "pricing.topUp.accessTitle": "Top-up access notice",
  "pricing.topUp.accessDesc":
    "Top-up packs are available only after you subscribe to a paid plan (Starter, Basic, or Pro).",
  "pricing.topUp.memberRequired": "Subscribe to a paid plan before purchasing top-up packs.",
  "pricing.topUp.gotIt": "Got it",
  "pricing.topUp.dialogTitle": "Choose a top-up pack",
  "pricing.topUp.dialogDesc":
    "One-off payment with no recurring billing. Top-up credits stay valid for one month from purchase.",
  "pricing.topUp.oneOffLabel": "One-off refill pack",
  "pricing.topUp.youReceive": "You Receive",
  "pricing.topUp.cancel": "Cancel",
  "pricing.topUp.purchase": "Purchase",

  "pricing.topup.small.name": "Small",
  "pricing.topup.small.price": "$99.90",
  "pricing.topup.small.credits": "6793 credits",
  "pricing.topup.small.note":
    "Original price, no discount. Suitable for first-time experience or temporary top-up.",
  "pricing.topup.large.name": "Large",
  "pricing.topup.large.price": "$199.90",
  "pricing.topup.large.credits": "13593 credits",
  "pricing.topup.large.creditsOriginal": "13000",
  "pricing.topup.large.note":
    "Extra about 500 points credited. Ideal for daily top-up.",
  "pricing.topup.super.name": "Super",
  "pricing.topup.super.price": "$299.90",
  "pricing.topup.super.credits": "20393 credits",
  "pricing.topup.super.creditsOriginal": "18500",
  "pricing.topup.super.note":
    "Extra about 1200 points credited. Ideal for frequent creation and bulk top-up.",
  "pricing.topup.ultra.name": "Ultra",
  "pricing.topup.ultra.price": "$399.90",
  "pricing.topup.ultra.credits": "27193 credits",
  "pricing.topup.ultra.creditsOriginal": "25000",
  "pricing.topup.ultra.note":
    "Adds about 2000 points credited. Perfect for high-point-demand creation.",

  "pricing.feature.brandInsight": "Brand Insight (times)",
  "pricing.feature.strategyPlan": "Strategy Plan (times)",
  "pricing.feature.imageGen": "Image Generation (times)",
  "pricing.feature.videoGen": "Video Generation (times)",
  "pricing.feature.viralMatch": "Viral Video Matching (times)",
  "pricing.feature.videoRemix": "Video Remix (times)",
  "pricing.feature.tkSolution": "TikTok Solution (times)",

  "pricing.featureQuota.title": "What you can generate",
  "pricing.featureQuota.footerNote": "Based on your monthly credits",

  "models.noModels": "No models match your filters.",

  "library.style": "Style",
  "library.playing": "Playing…",
  "library.paused": "Paused",
  "library.gender": "Gender",
  "library.ethnicity": "Ethnicity",

  "business.application": "Applications",
  "business.services": "Services",
  "business.platform": "Platform",
  "business.knowBrand": "KNOW",
  "business.knowBrandDesc":
    "Do you still lack precise insight into real consumer needs and the competitive landscape?",
  "business.buildBrand": "BUILD",
  "business.buildBrandDesc":
    "Are you facing insufficient high-quality content output, difficult cross-platform adaptation, and inefficient private-domain operations?",
  "business.manageBrand": "MANAGE",
  "business.manageBrandDesc":
    "Are you worried that brand data sits idle, crises erupt suddenly, and compliance risks slip out of control?",
  "business.scaleBrand": "SCALE",
  "business.scaleBrandDesc":
    "Are you stuck with global marketing that is hard to localize, inefficient ad delivery, and ROI you cannot predict accurately?",
  "business.marketInsight": "Market Insight",
  "business.consumerInsight": "Consumer Insight",
  "business.healthInsight": "Health Insight",
  "business.brandPositioning": "Brand Positioning",
  "business.brandStory": "Brand Story",
  "business.contentGeneration": "Content Generation",
  "business.socialMedia": "Social Media",
  "business.community": "Community",
  "business.dam": "Digital Assets",
  "business.sentiment": "Sentiment Analysis",
  "business.compliance": "Compliance",
  "business.customerService": "Customer Service",
  "business.sales": "Sales & Service",
  "business.seo": "GEO / SEO",
  "business.localization": "Localization & Global Growth",
  "business.email": "Email Marketing",
  "business.advertising": "Ads",
  "business.trend": "Trend & Revenue Forecasting",
  "business.voyaAI": "VoyaAI",
  "business.voyaAIDesc": "AI-native assistant for marketing workflows and creative acceleration.",
  "business.photoG": "PhotoG",
  "business.photoGDesc": "Multimodal content studio for brand-grade visuals and campaigns.",
  "business.dataG": "DataG",
  "business.dataGDesc": "Data intelligence layer for measurement, attribution, and growth signals.",
  "business.apiServices": "API Services",
  "business.apiServicesDesc": "Integrate OranAI capabilities into your stack with stable APIs and SLAs.",
  "business.agency": "Agency Program",
  "business.agencyDesc": "Partner enablement, co-selling, and dedicated success for agencies and studios.",

  "app.error.title": "Something went wrong",
  "app.error.hint": "An unexpected error occurred. You can try again.",
  "app.error.retry": "Try again",
  "app.error.showDetails": "Show technical details",
  "app.error.backHome": "Back to home",

  "notFound.title": "404",
  "notFound.description": "This page does not exist or has been moved.",
  "notFound.backHome": "Return to home",
};
